import { jsx } from "react/jsx-runtime";
import "react";
import { ChatMessagesContext } from "./ChatMessagesContext.js";
const ChatMessagesProvider = ({ children, value })=>/*#__PURE__*/ jsx(ChatMessagesContext.Provider, {
        value: value,
        children: children
    });
export { ChatMessagesProvider };
